import { DocumentType } from "@ctypes";

export type DocumentCategoryRouteState = {
  type: DocumentType;
  title: string;
};

export type DocumentItem = {
  id: string;
  title: string;
  documentDate: string;
  isRead: boolean;
};

export type DocumentSection = {
  title: string;
  data: DocumentItem[];
};

export const GROUPED_TYPES: DocumentType[] = [
  DocumentType.AccountStatement,
  DocumentType.TradeConfirmation,
];

export const UNDATED_SECTION_KEY = "__undated__";
